import util from '../util'

let controller = 'CarteiraConta'
export default Object.assign({}, util.GetCrud(controller, null), {
})
